export enum ColumnTypes {
    Text = 1,
    Numeric = 2,
    Calculated = 3,
    List = 4,
    RecordTypeSelect = 5,
    RecordTypeAutocomplete = 6
  }